import { render } from "./AuthLayout.vue?vue&type=template&id=296f4fd3"
import script from "./AuthLayout.vue?vue&type=script&lang=js"
export * from "./AuthLayout.vue?vue&type=script&lang=js"
script.render = render

export default script